// Mock data for Creassion Resources website

export const siteConfig = {
  name: "Creassion Resources",
  tagline: "Nurturing Faith in Children",
  logo: "https://customer-assets.emergentagent.com/job_f8c1ed42-ef40-4c66-bf3c-bf1b71f79eb6/artifacts/095cai12_Nuturing%20Faith%20in%20Children.png",
  email: "info@creassion.org",
  phone: "+44 7783 482935",
  charityNumber: "1214298",
  address: "England, United Kingdom",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61575731693728",
    instagram: "https://www.instagram.com/creassionresources/",
    youtube: "https://www.youtube.com/@CreassionResources"
  }
};

export const heroContent = {
  headline: "Discover Amazing Bible Stories!",
  subheadline: "Join our wonderful reading adventure where faith comes alive through beautiful stories, fun activities, and interactive books made just for you!",
  primaryCTA: "Start Reading",
  secondaryCTA: "Join Free",
  verse: {
    text: "Train up a child in the way he should go: and when he is old, he will not depart from it.",
    reference: "Proverbs 22:6"
  }
};

export const mission = {
  title: "Our Mission",
  description: "Creassion Resources exists to equip children and families with biblically sound, engaging, and accessible Christian resources that nurture faith, character, and spiritual growth.",
  vision: "We aim to bridge the gap in discipleship at home, church, and school by providing books, teaching tools, digital platforms, and parent support materials that make the Word of God irresistible to young hearts and minds.",
  approach: "Through research-led strategies, we develop innovative ways to capture children's attention, reinforce godly values, and support parents and churches in raising a generation rooted in truth, power, and love."
};

export const objectives = [
  {
    id: 1,
    title: "Advance Christian Faith",
    description: "Providing faith-based educational resources, books, and materials that teach biblical principles in an engaging and practical manner.",
    icon: "BookOpen"
  },
  {
    id: 2,
    title: "Spiritual Development",
    description: "Equipping children with resources that encourage Christian values and teachings in alignment with Proverbs 22:6.",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Free Resources",
    description: "Providing free Christian educational resources to schools, hospitals, churches, and organisations working with children.",
    icon: "Gift"
  },
  {
    id: 4,
    title: "Faith-Based Learning",
    description: "Encouraging and facilitating prayer, scripture reading, and faith-based learning among children everywhere.",
    icon: "Heart"
  }
];

export const resources = [
  {
    id: 1,
    title: "Children's Books",
    description: "Beautifully illustrated storybooks that bring Bible stories to life and teach godly values.",
    icon: "BookOpen",
    color: "coral"
  },
  {
    id: 2,
    title: "Teaching Tools",
    description: "Curriculum guides, activity sheets, and lesson plans for Sunday schools and Christian education.",
    icon: "GraduationCap",
    color: "blue"
  },
  {
    id: 3,
    title: "Digital Platforms",
    description: "Interactive apps and online resources that engage children in learning scripture.",
    icon: "Tablet",
    color: "teal"
  },
  {
    id: 4,
    title: "Parent Support",
    description: "Guides and materials to help parents nurture faith at home and lead family devotionals.",
    icon: "Users",
    color: "gold"
  }
];

export const statementOfFaith = [
  {
    id: 1,
    title: "The Trinity",
    content: "We believe in one God, who exists eternally in three persons: God the Father, God the Son (Jesus Christ), and God the Holy Spirit."
  },
  {
    id: 2,
    title: "The Holy Bible",
    content: "We believe in the Holy Bible as the inspired and infallible Word of God, guiding us in truth and righteousness."
  },
  {
    id: 3,
    title: "Jesus Christ",
    content: "We believe that Jesus Christ, the Son of God, was sent to redeem humanity. He died for our sins, rose again on the third day, and through Him, we have been reconciled with God the Father."
  },
  {
    id: 4,
    title: "The Gospel",
    content: "We believe that Jesus came to preach the Gospel to the poor, heal the brokenhearted, proclaim freedom to the captives, give sight to the blind, set the oppressed free, and declare the Lord's favor."
  },
  {
    id: 5,
    title: "The Holy Spirit",
    content: "We believe in the power and person of the Holy Spirit, who dwells within us, teaching us all things necessary for life and godliness."
  },
  {
    id: 6,
    title: "Faith in Love",
    content: "Our faith is rooted in love for God, expressed through our obedience to His Word and our love for others."
  }
];

export const team = [
  {
    id: 1,
    name: "Jadesola Ayoola",
    role: "Founding Trustee",
    bio: "Passionate about equipping the next generation with the Word of God."
  },
  {
    id: 2,
    name: "Naomi Tomisin",
    role: "Trustee",
    bio: "Dedicated to creating accessible faith resources for children."
  },
  {
    id: 3,
    name: "Ama Obeng",
    role: "Trustee",
    bio: "Committed to bridging the gap in children's discipleship."
  },
  {
    id: 4,
    name: "Eniola",
    role: "Illustrator",
    bio: "Bringing Bible stories to life through beautiful, engaging illustrations that capture children's imagination."
  }
];

export const impact = {
  stats: [
    { value: "500+", label: "Resources Distributed" },
    { value: "50+", label: "Partner Churches" },
    { value: "2,000+", label: "Children Reached" },
    { value: "15+", label: "Schools Supported" }
  ],
  beneficiaries: ["Schools", "Hospitals", "Churches", "Families", "Community Centers"]
};

export const testimonials = [
  {
    id: 1,
    quote: "Creassion Resources has transformed how we teach Bible stories to our Sunday school children. The materials are engaging and biblically sound.",
    author: "Pastor James O.",
    role: "Children's Ministry Leader"
  },
  {
    id: 2,
    quote: "As a parent, these resources have made family devotionals so much more meaningful. My children look forward to our Bible time together.",
    author: "Sarah M.",
    role: "Mother of 3"
  },
  {
    id: 3,
    quote: "The free resources provided to our school have been a blessing. Every child deserves access to faith-based learning.",
    author: "Mrs. Adebayo",
    role: "School Administrator"
  }
];

export const navLinks = [
  { name: "Home", href: "/", isPage: true },
  { name: "About", href: "/about", isPage: true },
  { name: "Resources", href: "/resources", isPage: true },
  { name: "Events", href: "/events", isPage: true },
  { name: "Readathon", href: "/readathon", isPage: true },
  { name: "Our Team", href: "/team", isPage: true },
  { name: "Volunteer", href: "/join-team", isPage: true },
  { name: "Shop", href: "/shop", isPage: true },
  { name: "Contact", href: "/contact", isPage: true }
];

// Membership tiers
export const membershipTiers = [
  {
    id: "free",
    name: "Explorer",
    price: "Free",
    description: "Start your faith journey",
    features: [
      "Access to selected preview books",
      "Standard page reading"
    ],
    color: "emerald",
    icon: "Leaf"
  },
  {
    id: "basic",
    name: "Adventurer",
    price: "£5/month",
    description: "Unlock the full library",
    features: [
      "Full access to all current digital books",
      "Automatic access to all future books",
      "Bookmark pages",
      "Track reading progress",
      "Personal library"
    ],
    color: "sky",
    icon: "Compass",
    popular: true
  },
  {
    id: "premium",
    name: "Champion",
    price: "£9/month",
    description: "The complete experience",
    features: [
      "Everything in Adventurer",
      "Early access to new books",
      "Draw directly on book pages"
    ],
    color: "amber",
    icon: "Crown"
  }
];

// Tree of Faith book pages - uploaded by user
export const treeOfFaithPages = [
  "https://customer-assets.emergentagent.com/job_bible-for-kids-2/artifacts/5zdz6m06_1.png", // Cover (page 1)
  null, // page 2 - inside cover (blank or will be added)
  "https://customer-assets.emergentagent.com/job_bible-for-kids-2/artifacts/7qr16bb8_3.png", // page 3
  "https://customer-assets.emergentagent.com/job_bible-for-kids-2/artifacts/vpwlq2kf_4.png", // page 4
  "https://customer-assets.emergentagent.com/job_bible-for-kids-2/artifacts/qbv1my14_5.png", // page 5
  "https://customer-assets.emergentagent.com/job_bible-for-kids-2/artifacts/dsmg7dbn_6.png", // page 6
  // Pages 7-50 to be uploaded by user
];

// Sample books for the library - Only Tree of Faith
export const sampleBooks = [
  {
    id: "book_tree_of_faith",
    title: "Tree of Faith",
    author: "Jadesola Ayoola",
    cover: "https://customer-assets.emergentagent.com/job_bible-for-kids-2/artifacts/5zdz6m06_1.png",
    pages: 50,
    ageRange: "4-10",
    category: "Faith Stories",
    description: "A beautiful illustrated story about growing in faith, featuring a magnificent tree overflowing with fruit - a symbol of the spiritual growth that comes from nurturing our relationship with God.",
    tier: "free",
    pageImages: treeOfFaithPages,
    pdfUrl: "https://customer-assets.emergentagent.com/job_bible-for-kids-2/artifacts/4az4q0x5_Tree%20of%20Faith%20KDP%20%288.625%20x%208.625%20in%29-2.pdf"
  }
];

// Nature-themed decorative elements
export const natureElements = {
  leaves: [
    { type: "leaf", color: "emerald", size: "sm" },
    { type: "leaf", color: "green", size: "md" },
    { type: "leaf", color: "teal", size: "lg" }
  ],
  flowers: [
    { type: "flower", color: "coral", petals: 5 },
    { type: "flower", color: "pink", petals: 6 },
    { type: "flower", color: "yellow", petals: 8 }
  ],
  animals: ["butterfly", "bird", "rabbit", "squirrel", "deer"]
};
